import { createContext } from 'react'
import { useJsApiLoader } from '@react-google-maps/api'
// import { config } from  './../config'
import config from '../config/config'
const { GOOGLE_MAP } = config

const MapContext = createContext()

const MapContextProvider = ({ children }) => {

  const { isLoaded } = useJsApiLoader({
    // googleMapsApiKey: config.apiKeyGoogleMaps,
    // libraries: config.librariesGoogleMaps
    googleMapsApiKey: GOOGLE_MAP.GOOGLE_API_KEY,
    libraries: GOOGLE_MAP.PLACES
  })

  return (
    <MapContext.Provider value={{ isLoaded }}>
      {children}
    </MapContext.Provider>
  )
}

export { MapContext, MapContextProvider } 